import { Grid } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { CommunityFeed } from './CommunityFeed';
import { JournalFeed } from './CommunityFeed/JournalFeed';
import styles from './CommunityHome.module.scss';
import { CommunityTabs } from './CommunityTabs';
import { AlbumsCard } from './CommunityTheFuture/AlbumsCard';
import { PhotoAlbums } from './CommunityTheFuture/PhotoAlbums';
import { WelcomeCard } from './WelcomeCard';

/**
 * Deux colonnes : la discussion à gauche, ce qui s'est passé sur le bien à droite.
 *
 * Les widgets météo, anniversaires, prochains séjours et soldes multi-biens ne sont plus
 * montés ici : ils n'avaient pas de rapport avec la conversation et noyaient la page.
 * Leurs composants restent dans le codebase.
 */
const CommunityHome = () => {
  const { t } = useTranslation();
  const isMedium = useMediaQuery('(min-width: 900px)');

  if (typeof isMedium !== 'boolean') {
    return null;
  }

  const header = (
    <div className={styles.pageHeader}>
      <h1 className={styles.title}>{t('community.pageTitle', 'Entre nous - le Tchat')}</h1>
      <p className={styles.subtitle}>
        {t(
          'community.subtitle',
          'Ce que vous mettiez dans le groupe WhatsApp, mais rangé par sujet et retrouvable dans dix ans.'
        )}
      </p>
    </div>
  );

  return (
    <div className={styles.screen}>
      {header}

      <WelcomeCard />

      {isMedium ? (
        <Grid>
          <Grid.Col span={8}>
            <CommunityFeed showMemories={false} />
          </Grid.Col>

          <Grid.Col span={4}>
            <AlbumsCard />

            <div className={styles.space} />

            <JournalFeed variant="compact" />

            <div className={styles.space} />

            <PhotoAlbums />
          </Grid.Col>
        </Grid>
      ) : (
        <CommunityTabs />
      )}
    </div>
  );
};

export default CommunityHome;
